import React from 'react'
import { connect } from "react-redux"
import moment from 'moment';
import DatePicker from 'react-datepicker';
import SelectTherapyCategories from '../admin/SelectTherapyCategories'
import TextareaAutosize from 'react-autosize-textarea';
import DocumentUpload from '../ui/DocumentUpload'
import FileImg from '../../images/icons/FileIcon'

import Swiper from 'react-id-swiper';
import Quill from 'quill';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';
import ReactHtmlParser from 'react-html-parser';

import { fetchPractices } from '../../actions/index'

import 'react-datepicker/dist/react-datepicker.css';

import FileUpload from '../ui/FileUpload'
import SearchIcon from '../../images/icons/SearchIcon';
import backArrowSvg from './images/arrow-right.svg';
import savedSVG from './images/saved.svg';
import trashRedSVG from './images/trashRed.svg';
import trashSVG from './images/trash.svg';
import penSVG from './images/pen.svg';

@connect((store) => {
  return {
    app: store.app,
    practice_types: [...store.practice_types],
    User: store.User.User,
    therapy_areas: store.therapy_areas,
    therapy_categories: store.therapy_categories,
    practices: store.practices
  };
})

class AssessmentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'internal': 'active',
      'parent': null,
      'sessionSaved': false,
      'internalNotesTickedAreas': [],
      'selectedAreas':[],
      'html': ''
    };
    this.swiper = null
    this.goNext = this.goNext.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.addNote = this.addNote.bind(this)
    this.noteTaking = this.noteTaking.bind(this)
    this.areaObject = this.areaObject.bind(this)
    this.findAreaByID = this.findAreaByID.bind(this)
    this.addDoc = this.addDoc.bind(this)
  }

  componentDidMount() {
    this.createQuill();
    //Close and save new session on back button press
    this.props.dispatch(fetchPractices());
    window.history.pushState(null, 'NewSession', window.location.href + '#assesmentForm')
    window.addEventListener('popstate', this.props.close);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.props.close);
  }

  backButtonModal() {
    window.history.back();
  }

  createQuill(){
    var el = document.querySelectorAll('#editor-container')[0];
    var quill = new Quill(el, {
      modules: {
        toolbar: [
          //[{ header: [1, 2, false] }],
          ['bold', 'italic', 'underline'],
          [{ 'list': 'bullet' }],
          [{ 'background': [false,'yellow'] }]
        ]
      },
      // placeholder: 'Compose an epic...',
      // value: this.props.assessment.internal_notes,
      theme: 'snow'  // or 'bubble'
    });


    // quill.setContents(convertHtmlToDelta(this.props.session.internal_notes));
    
    let that = this;
    quill.on('editor-change', function(eventName, ...args) {
      if (eventName === 'text-change') {
        // console.log(quill.getContents())
        // this.setState({internalNote: quill.getContent()})
        var delta = quill.getContents();
        var cfg = {};
        var ops = delta.ops;
        var converter = new QuillDeltaToHtmlConverter(ops, cfg);
        if(document.querySelectorAll('.ql-container')[0].childElementCount > 3) {
          // document.querySelectorAll('.ql-container')[0].querySelectorAll('p')[0].remove()
        }
        // var text = (this.props.assessment.internal_notes != '') ? this.props.assessment.internal_notes:'';
        var htm = converter.convert();
        that.setState({ 
          html:htm,
          internal: 'active'
        });
        that.props.assessment.internal_notes = htm;
        // console.log(html)

      } else if (eventName === 'selection-change') {
          that.setState({ 
            internal: 'active'
          });
        }
      });

      return quill;
  }

  toggleActivePanel(panel){
    if (panel === 'internal') {
      this.setState({
        internal: 'active',
        parent: '',
      });
      setTimeout(
        () => {
          let quill = this.createQuill();
          document.querySelectorAll('.ql-toolbar')[1].remove();
          quill.clipboard.dangerouslyPasteHTML(this.props.assessment.internal_notes);
        },
        100)
      setTimeout(
        () => {
        },250)
    } else {
      this.setState({
        parent: 'active',
        internal: null,
      })
    }
  }

  goNext() {
    //on clicking next button data is saved
    // this.props.saveSession(false, false)
    this.setState({ sessionSaved : true })
    if (this.swiper) this.swiper.slideNext()
  }

  goPrev() {
      //on clicking prev button data is saved
      // this.props.saveSession(false, false)
      this.setState({ sessionSaved : true })
      if (this.swiper) this.swiper.slidePrev()
    }

  addNote() {
    // if (this.props.assessment.internal_notes_array === undefined) {
    //   this.props.assessment.internal_notes_array = []
    // }

    // if (this.props.assessment.internal_notes_array.length < 1) {
    //   this.props.assessment.internal_notes_array.push(this.props.assessment.internal_notes)
    //   // this.props.assessment.internal_notes = ''
    // }
      this.toggleActivePanel('internal')
  }

  deleteNote(index){
    if (window.confirm('Are you sure you wish to delete this item?')) {
      this.props.assessment.internal_notes_array.splice(index, 1)
    }
    this.toggleActivePanel('internal')
  }

  editNote(index){
    let internalNote = this.props.assessment.internal_notes;

    if (internalNote === '') {
      this.props.assessment.internal_notes = this.props.assessment.internal_notes_array[index];
      this.props.assessment.internal_notes_array.splice(index, 1)
    } else {
      // this.props.assessment.internal_notes  = '';
    }
    this.toggleActivePanel('internal')
  }

  noteTaking(e) {
    // console.log(this.props);
    const { therapy_areas, therapy_categories, assessment, practice_types } = this.props;
    // console.log(assessment);
    let val = assessment.internal_notes + assessment.description;
    let selectedByNote = this.state.internalNotesTickedAreas;
    let selected_areas = assessment.therapy_areas;
    let searchExp = '';
    let practiceType = practice_types.find(({_id}) => _id === this.props.app.practice.practice_type);
    // console.log(practiceType);
    // console.log(therapy_areas);
    // console.log(therapy_categories);
    var filterArrayCategories = [];
    for (let key in therapy_categories) {
      if (therapy_categories.hasOwnProperty(key)) {
        if (therapy_categories[key].practice_type === practiceType.id) {
          filterArrayCategories.push(therapy_categories[key].id);
        }
      }
    }
    // console.log(filterArrayCategories);

    if (selectedByNote.length > 0) {
      selectedByNote.forEach(a => {
        if (selected_areas.length > 0) {
          // console.log('h');
          selected_areas.forEach(area => {
            setTimeout(() => {
              var ar = this.areaObject(area);
              if (ar.id === a._id) {
                // console.log('remove ar');
                // console.log(area);
                // console.log(a._id);
                this.props.assignTherapyArea(ar);
              }
            }, 1000)
          });
        }
      });
      selectedByNote = [];
    }

    if (val !== '') {
      for (let key in therapy_areas) {
        if (therapy_areas.hasOwnProperty(key)) {
          if (filterArrayCategories.some(item => therapy_areas[key].categories.includes(item))) {
            let searchString = therapy_areas[key].name;
            searchString = searchString.replace(/\s*$/, "");
            searchString = searchString.replace('(', '\\(');
            searchString = searchString.replace(')', '\\)');
            searchExp = new RegExp("(" + searchString + ")", 'i');
            if (val.match(searchExp)) {
              setTimeout(() => {
                this.props.assignTherapyArea(therapy_areas[key]);
                selectedByNote.push(therapy_areas[key]);
              }, 1000);
            }
          }
        }
      }
    }
    this.setState({
      internalNotesTickedAreas: selectedByNote
    });
  }

  areaObject (areaId) {
    let area = null;
    const { therapy_areas } = this.props;
    for (let key in therapy_areas) {
      if (therapy_areas.hasOwnProperty(key)) {
        if (therapy_areas[key].id === areaId) {
          area = therapy_areas[key];
        }
      }
    }
    return area;
  }

 findAreaByID(areas, id) {
    // console.log(id)
    // console.log(areas)
    let selected = []

    let area = []
    if (id !== undefined && id.length > 0){
      id.forEach(i => {
        area.push(_.filter(areas, ['_id', i]))
      })
      area.forEach(a => {
        if (a !== undefined) {
          selected.push(a[0].name)
        }
      })
    }

    return selected;
  }

  addDoc(doc) {
    this.props.addDocument(doc);
  }

  render() {

    const props = this.props
    // console.log(props)

    if (props.assessment.description === undefined) {
      props.assessment.description = ''
    }

    if (props.assessment.therapy_areas === undefined) {
      props.assessment.therapy_areas = []
    }

    if (props.assessment.internal_notes === undefined || props.assessment.internal_notes === '' ) {
      props.assessment.internal_notes = ''
    }
        
    // console.log(this.props)

    const fileStyle = {
      height: '18px',
      opacity: '0.5',
      display: 'inline',
      transform: 'translateY(2px)'
    }
    const swiperParams = {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      spaceBetween: 10,
      observer: true,
      observeParents: true,
      noSwiping: true,
      noSwipingClass: 'swiper-wrapper',
      autoHeight: true
    }

    const attachmentButton = {
      'margin-bottom': '4em'
    }

    return <div id="assesmentFormScroll" className="assesmentFormScroll basicAssesmentFormScroll">
    <div className="newAssesmentForm md-list wide marginless card">
    <div className="assesmentHeader">
          <div className="close link" onClick={this.backButtonModal}><img src={backArrowSvg}  alt="back Arrow"/></div>
    <span className="title">{props.patient.firstName} {props.patient.lastName} - New Assessment</span>
    {/* <div className={'savedIcon saved'}>
    toggle the saved class above to show and hide 
    <img src={savedSVG} alt="save icon"/>
    <span>SAVED</span>
    </div>*/}
    </div>

    {/* Swiper Slide 1 */}
    <Swiper {...swiperParams} ref={node => this.swiper = node !== null ? node.swiper : null } >
    <div className="swiper-slide swiperPage1">
    <div className="datePicker">
          {/* <div className="md-subtitle">Date of assessment</div>
          <small className="quiet">Cant be before patient's birth date ({moment(props.patient.dob).format('YYYY-MM-DD')})</small>
        <br /> */}
        <label>Date of Assessment</label>
        <input className="md-input md-title hide"
        autoComplete="off"
        onChange={(e) => props.handleFormChange(e, 'doa')}
        value={moment(props.assessment.doa).format('YYYY-MM-DD HH:mm')}
        placeholder="Date of Assessment"
        type="date" placeholder="yyy/mm/dd - hh:mm" style={
          {
            'borderBottom': 'none'
          }
        } />

        <DatePicker
        popperPlacement="bottom-end"
        selected={moment(props.assessment.doa) || props.assessmentStartDate}
        onChange={props.handleDOAChange}
        timeIntervals={30}
        dateFormat="YYYY/MM/DD"
        showYearDropdown
        popperModifiers={{
          flip: {
              behavior: ["bottom"] 
          },
          preventOverflow: {
              enabled: false 
          },
          hide: {
              enabled: false 
          }
        }}
        />
        </div>
        <div className={this.state.internal ? "internalAndParentNotes" : "internalAndParentNotes hideToolbar"}>
          {/* <div className="md-subtitle">Parent Notes <small>(visible to you and the patient's parents)</small></div> */}

            <div className="headerButtons">
                <div>
                  Notes
                {this.state.internal ? <small>Visible only to you</small> : ''}
                </div>
                <div>
                  {/* add active class below to wichever is active */}
                    <button onClick={(e) => this.toggleActivePanel('internal')} className={this.state.internal}>Internal</button>
                    <button onClick={(e) => this.toggleActivePanel('parent')} className={this.state.parent}>Public</button>
                </div>
            </div>

            { this.state.internal &&
              <div
                id="editor-container"
                style={{'height': '375px'}}
                onChange={(e) => this.props.handleFormChange(e, 'internal_notes')}
                onBlur={(e) => this.noteTaking(e)}
                >
              </div> }
            { !this.state.internal &&
              <TextareaAutosize className="md-body-1 inputTextArea"
                value={props.assessment.description}
                placeholder={'Enter your parent notes here...'}
                onChange={(e) => this.props.handleFormChange(e, 'description')}
                onBlur={(e) => this.noteTaking(e)}
              /> }
         
          
          {/* <div className="md-subtitle">Internal Notes <small>(only visible to you)</small></div> */}
         
          {/* <TextareaAutosize className="md-input md-body-1 multiple"
            value={props.assessment.internal_notes}
            placeholder="Internal assessment notes"
            onChange={(e) => props.handleFormChange(e, 'internal_notes')}
          /> */}

          { this.state.internal ?
            <div className="addImage">
                <button onClick={ this.addNote }>SAVE NOTE</button>
            </div>
          : '' }
        </div>

        <div className="notesAdded">
        {/*Notes Added
        {props.assessment.internal_notes_array !== undefined && props.assessment.internal_notes_array.length > 0 ?
            props.assessment.internal_notes_array.map((note, index) =>
              <div className="notesBox" key={`note-box-${index}`}>
                <div>
                  <span>Internal</span>
                  <a onClick={() => this.deleteNote(index)}><img src={trashSVG} alt="Delete"/></a>
                  <a onClick={() => this.editNote(index)}><img src={penSVG} alt="Edit"/></a>
                </div>
                <p>{ note }</p>
                <div>
                { props.assessment.internal_images !== undefined ? <div className="photo"></div> : '' }
                </div>
              </div> )
          : ''} */}

        {/*
        {props.assessment.description !== undefined && props.assessment.description.length > 0 ?
          <div className="notesBox">
            <div>
              <span>Parent</span>
              <img src={trashSVG} alt="Delete"/>
              <img src={penSVG} alt="Edit"/>
            </div>
            <p>{ props.assessment.description }</p>
            <div>
              { props.assessment.uploadedImages !== undefined ? <div className="photo"></div> : '' }
            </div>
          </div> : ''}*/}
        </div>
      </div>
      {/* End Of Slide 1 */}

    {/* SLIDE 2 */}
    <div className="swiper-slide swiperPage2">
    
      <div className="notesDate">
        <div>
          <p><strong>Date:</strong> {moment(props.assessment.doa).format('YYYY-MM-DD HH:mm')}</p>
          <p><strong>Notes:</strong> { props.assessment.internal_notes !== undefined ? 1 : 0 } Internal - { props.assessment.description !== undefined && props.assessment.description.length ? 1 : 0 } Parent</p>
          <p><strong>Images:</strong> { props.assessment.internal_images !== undefined ? props.assessment.internal_images.length : 0 } Internal - { props.assessment.uploadedImages !== undefined ? props.assessment.uploadedImages.length : 0 } Parent</p>
        </div>
      </div>
    
    <div>
      <div className="selectedAreasContainer">
          <b>Selected Areas:</b>       
          <div>
          { 
            this.findAreaByID(props.therapy_areas, props.assessment.therapy_areas).map((area, key) => (<span key={`area-key-${key}`}>{ area }</span>))
          }
          {props.assessment.therapy_areas.length === 0 && <span>No therapy areas selected</span>}
          </div>
      </div>
      <SelectTherapyCategories
          click={props.assignTherapyArea}
          checkedCond={area => { return props.assessment.therapy_areas.indexOf(area._id) !== -1 }
          }
          therapy_areas={props.therapy_areas} 
        />
      </div>

      {/* <div className="card-content">
      <div className="md-subtitle">Documents</div>
      </div> */}

      {props.assessment.documents ? (
        <div>
        <div className="card-content">
        {props.assessment.documents.map(doc => {
          return <p key={`doc-${doc.name}`}>
          <a className="link right" onClick={() => props.deleteDocument(doc, props.assessment)}><small>Delete</small></a>
          <FileImg style={fileStyle} /><a href={`${doc.url}`} target="_new">{doc.name}</a>
          </p>
        })}
        </div>
        </div>) : null}
      <div className="row assesmentButton" style={attachmentButton}>
      <div className="fill">
      {/*<button className="md-button" onClick={props.save}>Save</button>*/}
      </div>
      <div>
      <DocumentUpload callback={this.addDoc} path={`documents/assessments/patients/${props.patient._id}/`} />
      </div>
      </div> 
      </div>
    {/* END SIDE 2 */}
    </Swiper>

    <div className="modal-footer">
      <a onClick={this.goPrev} className="">Back</a>
      { this.swiper !== null && this.swiper.isEnd ? <a onClick={props.save} className="">Send</a> : <a onClick={this.goNext} className="">Next: Therapy Areas</a> }
    </div>
    </div>

    </div>
  }
}

AssessmentForm.defaultProps = {
  patient: {},
  attachImage: () => { },
  removeImage: () => { },
  assessment: {
    therapy_areas: []
  },
  newSessionSelectVideosOpen: false
}


export default AssessmentForm;



// WEBPACK FOOTER //
// ./src/components/therapist/AssessmentForm.jsx